const axios = require('axios');

const _validateEmail = (email) => {
    const API_URL = require('./API.js')();
    try {
        return axios({
            method: "get",
            url: `${API_URL}/api/v1/helpers/is-email-available`,
            params: {
                email: email
            },
        });
    } catch (error) {
        console.error(error);
    }
};

const _createCustomer = (customers) => {
    const API_URL = require('./API.js')();
    console.log(customers)
    try {
        return axios.post(`${API_URL}/api/v1/customer`, customers);
    } catch (error) {
        console.error(error);
    }
};

const _plans = () => {
    const API_URL = require('./API.js')();
    try {
        return axios.get(`${API_URL}/api/v1/plan`);
    } catch (error) {
        console.log(error);
    }
}

const _createCheckoutSession = checkOut => {
    const API_URL = require('./API.js')();
    try {
        return axios.post(`${API_URL}/api/v1/orders/check-out`, checkOut);
    } catch (error) {
        console.log(error);
    }
}

module.exports = {
    _validateEmail,
    _createCustomer,
    _plans,
    _createCheckoutSession
}